<template>
  <div>
    <b-nav-item-dropdown :right="right" :no-caret="noCaret" class="mr-3 profile" v-if="id!=null">
      <template slot="button-content">
        <slot name="header">&#10068;</slot>
      </template>
      <slot name="dropdown">
        <div class="dropdown-content">
          <span class="text-center">dropdown</span>
        </div>
      </slot>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown :right="right" :no-caret="noCaret" class="mr-3 profile" v-else>
      <template slot="button-content">
        <slot name="signin">&#10068;</slot>
      </template>
      <b-dropdown-item>
        <router-link to="/login">
          <i class="fa fa-lock" /> Sign in
        </router-link>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>
<script>
export default {
  name: "HeaderDropdown",
  props: {
    right: {
      type: Boolean,
      default: false
    },
    noCaret: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    id() {
      return this.$store.getters["auth/getUserID"];
    }
  },
};
</script>
<style scoped>
.profile {
  margin-right: 28px !important;
  padding: 11px;
  margin-top: -11px !important;
  border: 1px;
}

.dropdown-content {
  right: auto;
  height: 200px;
}

</style>

<style>
  .app-header .dropdown-item {
  min-width: 100px !important;
}
</style>
